import React from 'react'

function InputDivider ({color = '#DFDFDF'}) {
  return (
    <div className={'input-divider'} style={{ background: color }}></div>
  )
}

export default InputDivider